import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useOfferFile() {
  const fileId = useAppSelector(({ offerReducer: { createOrUpdate } }) => createOrUpdate?.files)?.[0];

  const { data, ...arg } = useQuery<{
    id: number;
    name: string;
    size: number;
    originalName: string;
    absolutePath: string;
  }>(
    ['offer-file', fileId],
    async () => {
      const { data } = await $api.get(`/v1/files/${fileId}`);

      return data?.data;
    },
    {
      enabled: !!fileId
    }
  );

  return { ...data, ...arg };
}
